import React, { useState, useEffect } from 'react';
import { MainHeading } from 'application/Components/UI/Heading/MainHeading';
import { useDispatch, useSelector } from 'react-redux';
import EnterUsername from './AuthenticationSteps/EnterUsername';
import EnterPassword from './AuthenticationSteps/EnterPassword';
import useAppids from 'hooks/useAppids';
import {
  loginSelector,
  onChange,
  setError,
} from 'store/reducers/login/login.slice';
import { signInSteps } from 'store/reducers/login/login.helper';
import { useNavigate } from 'react-router-dom';
import {
  defaultRpsErrorObj,
  rpsLoginErrors,
} from 'store/reducers/login/login.helper';
import { updateError } from 'store/reducers/errors/errors.slice';
import storage from 'utils/storage';
import { storageNames } from '../../../../constants';
import { MainSectionLayout } from 'application/Components/UI/Layouts/Layout';
import { loginPageTitles } from 'application/configurations/pageTitle.config';
import VideoGuide from 'application/Components/VideoGuide/VideoGuide';

const SignInSection = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { appid, isRpsAppid, isVitalityAppid } = useAppids();
  const title = loginPageTitles[appid];
  const { signInStep } = useSelector(loginSelector);
  const [isVideoModalVisible, setVideoModalVisible] = useState(false);

  useEffect(() => {
    initiateRpsErrors();
    initiateUsername();
  }, []);

  const initiateRpsErrors = () => {
    if (!isRpsAppid || signInStep !== signInSteps.username) return;

    const urlParams = new URLSearchParams(window.location.search);
    const msg = urlParams.get('msg');
    if (!msg) return;

    const { type, errorMessage, path } =
      rpsLoginErrors[msg] || defaultRpsErrorObj;

    if (type === 'navigate') {
      navigate(`${path}${window.location.search}`);
      dispatch(updateError(msg));
    } else {
      dispatch(setError({ username: errorMessage }));
    }
  };

  const initiateUsername = () => {
    const localUsername = storage.local.get(
      storageNames.REMEMBER_USERNAME_VALUE,
    );
    if (localUsername) {
      dispatch(onChange({ username: localUsername }));
    }
  };

  return (
    <MainSectionLayout>
      <MainHeading>{title}</MainHeading>
      {isVitalityAppid && (
        <VideoGuide
          isVideoModalVisible={isVideoModalVisible}
          setVideoModalVisible={setVideoModalVisible}
        />
      )}
      {signInStep === signInSteps.username && <EnterUsername />}

      {signInStep === signInSteps.password && <EnterPassword />}
    </MainSectionLayout>
  );
};

export default SignInSection;
